import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import { SITE } from "../data/site";
import { scrollToSection } from "../lib/navigation";

/** Banda de conversión reutilizable entre secciones largas. */
export default function CtaBand({ title, text }) {
  const { t } = useTranslation();

  return (
    <section className="fsg-section fsg-section--tight">
      <div className="fsg-container">
        <Reveal className="fsg-cta">
          <div>
            <h2>{title ?? t("contact.title")}</h2>
            <p>{text ?? t("contact.lead")}</p>
          </div>
          <div className="fsg-cta__actions">
            <button
              type="button"
              className="fsg-btn fsg-btn--primary fsg-btn--lg"
              onClick={() => scrollToSection("contacto")}
            >
              {t("cta.primaryLong")}
              <Icon name="arrow" />
            </button>
            <a
              className="fsg-btn fsg-btn--outline-invert"
              href={`tel:${SITE.phone}`}
            >
              <Icon name="phone" />
              {SITE.phoneDisplay}
            </a>
            <p className="fsg-cta__note">{t("hero.ctaNote")}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
